import {FilteringFlow} from '@filtering.js/filtering.js/ui';
import {animateInViewport} from '../transition';
import {esc_title} from '../utils';
import {loadMore} from '../load-more';

const filterCheckedClass = 'active'
const filteredItemClass = 'hidden'

$(function () {
  for (const filteringElement of document.querySelectorAll('.filtering')) {
    const searchElement = filteringElement.querySelector('input[type="search"]')
    for (const searchEvent of ['keyup', 'search']) {
      searchElement?.addEventListener(searchEvent, (event) => {
        filteringFlow.filter()
      })
    }

    class MyFilteringFlow extends FilteringFlow {
      get parserOptions() {
        return {filterCheckedClass}
      }

      get filteringOptions() {
        return {
          filterItem: (item, schema) => {
            if (searchElement) {
              const itemSearchText = esc_title(
                item.data.element.dataset.searchText || '',
              ).toLowerCase()
              return this.getSearchedWords().every((searchWord) =>
                itemSearchText.includes(searchWord.toLowerCase()),
              )
            }
            return true
          },
        }
      }

      getSearchedWords() {
        if (searchElement) {
          return searchElement.value
            .split(/\s+/g)
            .filter((w) => w !== '')
            .map(esc_title)
        }
        return []
      }

      handleFilterResult(result, filterData) {
        super.handleFilterResult(result)

        for (const noResultsElement of filteringElement.querySelectorAll('.no-results')) {
          noResultsElement.classList.toggle('hidden', result.filteredItems.length > 0)
        }

        this.updateLoadMore(filteringElement, result)
        this.updateAllFilters(result, filterData)
        this.updateItemClasses(result, filterData)
        setTimeout(animateInViewport, 0)
      }

      updateAllFilters(result, filterData) {
        const areAllFilterChecked = this.areAllFiltersChecked(result)
        for (const group of result.schema.groups) {
          for (const filter of group.filters) {
            const filterElement = filter.data.element
            if (filterElement.dataset.filterType === 'all') {
              filterElement.classList.toggle(filterCheckedClass, areAllFilterChecked)
            }
          }
        }
      }

      areAllFiltersChecked(result) {
        for (const groupResult of result.groups) {
          for (const filterResult of groupResult.filters) {
            const filterElement = filterResult.schemaFilter.data.element
            if (
              filterElement.dataset.filterType !== 'all' &&
              filterElement.classList.contains(filterCheckedClass)
            ) {
              return false
            }
          }
        }
        return true
      }

      updateItemClasses(result, filterData) {
        if (filteringElement.classList.contains('filtering-posts')) {
          const isFiltering =
            filterData.checkedFilters.size > 0 || this.getSearchedWords().length > 0
          for (const [itemIndex, item] of result.filteredItems.entries()) {
            const itemElement = item.data.element
            itemElement.classList.toggle('lg:col-span-6', !isFiltering && itemIndex < 2)
            itemElement.classList.toggle('lg:col-span-4', isFiltering || itemIndex >= 2)
          }
        }

        const delayClasses = ['delay-[33ms]', 'delay-[66ms]', 'delay-[99ms]']
        for (const [itemIndex, item] of [
          ...$(filteringElement).find(
            '.filtering-item:not(.hidden), .filtering-item.load-more-hidden',
          ),
        ].entries()) {
          const $item = $(item)
          for (const [delayClassIndex, delayClass] of delayClasses.entries()) {
            $item.toggleClass(delayClass, itemIndex % delayClasses.length === delayClassIndex)
          }
          $item.removeClass('wait-to-animate')
        }
      }

      updateLoadMore(element, result) {
        const loadMoreElements = element.querySelectorAll('.load-more')
        if (loadMoreElements.length === 0) {
          return
        }

        for (const loadMoreContainerElement of element.querySelectorAll('.load-more-container')) {
          loadMoreContainerElement.classList.toggle('hidden', result.filteredItems.length === 0)
        }
        for (const item of result.allItems) {
          item.data.element.classList.add('load-more-hidden')
          item.data.element.classList.remove('active')
        }
        loadMore($('.load-more', element))
      }
    }

    const filteringFlow = new MyFilteringFlow(filteringElement, {
      filteredItemClass,
    })
  }
})
